import classNames from 'classnames'
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { ControlLabel, Radio } from 'react-bootstrap'

class PaymentChoiceTypeButton extends PureComponent {
  render () {
    const className = classNames(
      'control-label payment-choice__type-button',
      {
        'disabled': this.props.disabled,
        'hidden-xs': this.props.activatePaypal && !this.props.activatePaypal.mobile,
        'hidden-lg': this.props.activatePaypal && !this.props.activatePaypal.largeComputer,
        'hidden-md': this.props.activatePaypal && !this.props.activatePaypal.smallComputer,
        'hidden-sm': this.props.activatePaypal && !this.props.activatePaypal.tablet
      })
    return (
      <ControlLabel className={className}>
        <Radio
          bsClass=''
          checked={this.props.checked}
          disabled={this.props.disabled}
          id={this.props.id}
          name='paymentChoice'
          onChange={() => this.props.onChange(this.props.value)}
          value={this.props.value}>
          {this.props.children}
        </Radio>
      </ControlLabel>
    )
  }
}

PaymentChoiceTypeButton.defaultProps = {
  disabled: false
}

PaymentChoiceTypeButton.propTypes = {
  checked: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  activatePaypal: PropTypes.shape({
    mobile: PropTypes.bool,
    largeComputer: PropTypes.bool,
    smallComputer: PropTypes.bool,
    tablet: PropTypes.bool
  }),
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
}

export default PaymentChoiceTypeButton
